import { resolveChoiceSubtype } from '../infer';
import type { PersonalPageSubtype } from '../subtypes';
import { cap } from './capability-builder';
import { SUBTYPE_CAPABILITIES } from './definitions';
import type { PersonalPageCapabilities } from './types';

/** When subtype is already effective (via resolveEffectiveSubtype), registrationType is not needed. */
export function resolveCapabilities(
  subtype: PersonalPageSubtype | undefined,
  registrationType?: 'form' | 'tickets'
): PersonalPageCapabilities {
  if (!subtype) {
    return cap({
      label: '',
      dataDestination: 'registrations',
      defineStepLabelConfig: { formSubject: 'דף' }
    });
  }
  const isChoiceSubtype = subtype === 'choiceDonation' || subtype === 'choiceEvent';
  const resolved =
    isChoiceSubtype && registrationType !== undefined ? resolveChoiceSubtype(subtype, registrationType) : subtype;
  return (
    SUBTYPE_CAPABILITIES[resolved] ??
    cap({
      label: '',
      dataDestination: 'registrations',
      defineStepLabelConfig: { formSubject: 'דף' }
    })
  );
}
